import CONSTANTS from '~/constants'
import { getRevisionHistory } from '~/api/story'

function revisionHistory($http, $q, $timeout, $rootScope) {
  this._isFresh = false

  const flush = () => {
    this._isFresh = false
  }

  const fetchBranches = function (storyId) {
    return $http({
      method: 'GET',
      url: `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_API}/v1/get/${storyId}/branch/`,
      timeout: 10000,
    })
  }

  this.branches = []
  this.revisions = []
  this._isFresh = false

  this.flush = () => {
    this._isFresh = false
  }

  $rootScope.$on('SAVE_SUCCESS', this.flush)

  this.fetchRevisions = function (storyId) {
    const defer = $q.defer()

    // Implemente a lock later if the User Exp brakes.
    const fetchRevisionsSuccess = (response) => {
      this._isFresh = true
      this.revisions = response
      defer.resolve(response)
    }

    const fetchRevisionsFailure = (response) => {
      this._isFresh = false
      defer.reject(response)
    }

    if (storyId === null) {
      // defer.resolve({data: []})
      defer.reject('Story Id not supplied')
      return defer.promise
    }

    if (this._isFresh === true) {
      defer.resolve(this.revisions)
    } else {
      getRevisionHistory(storyId)
        .then((data) => {
          fetchRevisionsSuccess(data.legacyRevisionList)
        })
        .catch(fetchRevisionsFailure)
    }

    return defer.promise
  }

  // TODO: is this needed?
  $rootScope.$on('SAVE_SUCCESS', flush)

  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  this.copyRevisionToCurrent = function (storyId, revisionId) {}

  this.fetchBranchesForStory = (storyId) => {
    const defer = $q.defer()

    if (this._isFresh === true) {
      $timeout(
        function fetchRevisionsSkipABeat() {
          defer.resolve({ data: this.branches })
        }.bind(this),
        0
      )
    } else {
      fetchBranches(storyId).then((response) => {
        this.branches = response.data.slice()
        defer.resolve(response)
      })
    }

    return defer.promise
  }
}

export default [
  '$http',
  '$q',
  '$timeout',
  '$rootScope',
  'featureFlagService',
  revisionHistory,
]
